import React, { createContext, useContext, useEffect, useState } from "react";
import {
  applyDocumentLanguage,
  getStoredLanguage,
  VISITOR_LANGUAGE_CHANGE_EVENT,
} from "./translate";

const VisitorLanguageContext = createContext("fa");

export function VisitorLanguageProvider({ children }) {
  const [lang, setLang] = useState(() => getStoredLanguage());

  useEffect(() => {
    applyDocumentLanguage(lang);
  }, [lang]);

  useEffect(() => {
    const handleLanguageChange = (event) => {
      setLang(event.detail?.lang || getStoredLanguage());
    };

    window.addEventListener(VISITOR_LANGUAGE_CHANGE_EVENT, handleLanguageChange);
    return () => {
      window.removeEventListener(
        VISITOR_LANGUAGE_CHANGE_EVENT,
        handleLanguageChange
      );
    };
  }, []);

  return (
    <VisitorLanguageContext.Provider value={lang}>
      {children}
    </VisitorLanguageContext.Provider>
  );
}

export function useVisitorLanguage() {
  return useContext(VisitorLanguageContext);
}
